import script from "./ticker.vue?vue&type=script&setup=true&lang=js"
export * from "./ticker.vue?vue&type=script&setup=true&lang=js"

import "./ticker.vue?vue&type=style&index=0&id=3ac062ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ac062ca"]])

export default __exports__